<template>
  <div class="page" style="background-color: #ffffff;width: 100%;height: 100%">
    <van-nav-bar
      title="顾客交易历史"
      left-text="返回"
      left-arrow
      fixed
      @click-left="historyBack"
    />
  <el-table :data="cardtranhistorys" border style="width: 100%;margin-top: 45px" height="calc(100% - 45px)" size="mini">
    <el-table-column prop="billtype"    label="单据类型" width="80">
        <template slot-scope="scope">
              {{$getBillName(scope.row.trantype)}}
        </template>
    </el-table-column>
    <el-table-column prop="projectname" label="项目名称"></el-table-column>
    <el-table-column prop="accountdate" label="日期" width="80">
      <template slot-scope="scope">
        {{$moment(scope.row.accountdate).format("YYYY-MM-DD")}}
      </template>
    </el-table-column>
    <!--<el-table-column prop="amount"      label="金额" ></el-table-column>-->
  </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cardtranhistorys: [],
      cardid: "",
    }
  },
  created() {
    this.cardid=this.$route.query.cardid;
    this.getCardTranHistoryByDept();
  },
  methods:{
    getCardTranHistoryByDept(){
      this.$post("ddstaff/getCardTranHistoryByDept",{cardid:this.cardid}).then(res=>{
        if(res.sucess){
          this.cardtranhistorys=[];
          for(let val of res.object){
            this.cardtranhistorys.push(val.cardTransactionHistory);
          }
        }
        else{
          this.$message.error(res.message);
        }
      });
    }
  }
}
</script>
<style style lang="scss" rel="stylesheet/scss">
.page .el-table{
  font-size:10px;
}
</style>



// WEBPACK FOOTER //
// src/page/hair/cardtranhistory.vue